import React from "react";
import { Card, Embed, Image } from "semantic-ui-react";
import { Blurhash } from "react-blurhash";
import { ThumbnailStyledCard } from "../styled-components";

const Thumbnail = ({ src, alt, footerVisible, onLoad, parsedLink }) => (  
  <a href={parsedLink} target="_blank" rel="noreferrer">
    <Image
      src={src}
      alt={alt}
      wrapped
      ui={false}
      onLoad={onLoad}
      className={`generic-thumbnail${footerVisible ? "" : " no-footer"}`}
    />
  </a>
);

const ThumbnailNoLink = ({ src, alt, footerVisible, onLoad }) => (
  <Image
    src={src}
    alt={alt}
    wrapped
    ui={false}
    onLoad={onLoad}
    className={`generic-thumbnail${footerVisible ? "" : " no-footer"}`}
  />
);

const VideoContainer = ({ media, poster, onLoadStart }) => (
  <div className="video-container">
    <video
      key={media}
      controls
      poster={poster}
      preload="none"
      onLoadStart={onLoadStart}
    >
      <source src={media} id="Sharers Video" />
    </video>
  </div>
);

const ThumbnailCard = (props) => {
  const {
    mediaType,
    parsedLink,
    onVideoLoadCallback,
    onMediaLoadCallback,
    displayImageFooter,
    linkCaption,
    media,
    image,
    resolvedMedia,
    textColor,
    font
  } = props;

  const blurhash = image?.blurhash;

  const renderMediaType = () => {
    switch (mediaType) {
      case "youtube":
        return (
          <Embed
            id={image.filename}
            placeholder={media}
            source="youtube"
            className="video"
          />
        );
      case "video":
        const poster = resolvedMedia ? resolvedMedia.thumbnail_media.url : "";
        return (
          <VideoContainer
            media={resolvedMedia ? resolvedMedia.url : ""}
            poster={poster}
            onLoadStart={onVideoLoadCallback}
          />
        );
      case "image":
        return (
          <>
          {(displayImageFooter) ? 
          <Thumbnail
            src={media}
            alt={blurhash ? "" : "Thumbnail"}
            footerVisible={displayImageFooter}
            onLoad={onMediaLoadCallback}
            parsedLink={parsedLink}
          />
          :
          <ThumbnailNoLink
            src={media}
            alt={blurhash ? "" : "Thumbnail"}
            footerVisible={displayImageFooter}
            onLoad={onMediaLoadCallback}
          />
         }
        </>
        );
      case "giphy":
      case "gif":
        return (
          <ThumbnailNoLink
            src={media}
            alt={blurhash ? "" : "Thumbnail"}
            footerVisible={displayImageFooter}
            onLoad={onMediaLoadCallback}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="thumbnail-container">
      <ThumbnailStyledCard
        textColor={props.textColor}
        font={props.font}
      >
        <div className="media-container">
        {blurhash &&
        <Blurhash
            hash={blurhash}
            width="100%"
            height="100%"
            className={`post-blurhash${displayImageFooter ? "" : " no-footer"}`}
          />
        }

        {(!image?.externalMediaID || (image?.externalMediaID && resolvedMedia)) 
            ? renderMediaType()
            : <div className="media-element-loading"></div>}
        </div>
        {displayImageFooter && (
          <Card.Content>
            <a
              href={parsedLink}
              target="_blank"
              className="postcard-link"
              rel="noreferrer"
            >
              <Card.Header className="post-linkcaption" >
                {linkCaption}
              </Card.Header>
              <Card.Meta className="post-link">
                {parsedLink && new URL(parsedLink).hostname}
              </Card.Meta>
            </a>
          </Card.Content>
        )}        
      </ThumbnailStyledCard>
    </div>
  );
};

export default ThumbnailCard;
